import React from 'react'
import clsx from 'classnames'
import facebookIcon from 'assets/social-facebook.svg'
import vkIcon from 'assets/social-vk.svg'
import instagramIcon from 'assets/social-inst.svg'
import telegramIcon from 'assets/social-tg.svg'
import styles from './Social.module.css'

export type SocialType = 'facebook' | 'vk' | 'instagram' | 'telegram'

const ICONS: Record<SocialType, string> = {
  facebook: facebookIcon,
  vk: vkIcon,
  instagram: instagramIcon,
  telegram: telegramIcon,
}

type SocialProps = {
  type: SocialType,
  link?: string,
  place: 'header' | 'footer',
}

export const Social: React.FC<SocialProps> = (props) => {
  const { type, link, place } = props
  const iconClassName = clsx({
    [styles.imgSettingsNavHeader]: place === 'header',
    [styles.imgSettingsNavFooter]: place === 'footer',
  })
  return (
    <a href={link} target={'_blank'} className={styles.imgLink} rel="noopener noreferrer">
      <img src={ICONS[type]} alt={type} className={iconClassName} />
    </a>
  )
}
